interface AppErrorOptions extends ErrorOptions {
  code?: string;
}
export class AppError extends Error {
  code?: string;

  constructor(message: string, options?: AppErrorOptions) {
    super(message, options);

    this.code = options?.code || "DEFAULT"; // TODO: review all this with src/routes/error.tsx
  }
}
